module.exports = __webpack_public_path__ + "img/1526988311.412d4bc6.jpg";